import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from '../../hooks/redux'
import { setActiveTab } from '../../store/slices/voiceGroups/voiceGroupsSlice'
import { Container } from '../../components/container'
import { CustomButton } from '../../components/customButton'
import { VoicesTab } from '../../layouts/voices/voicesTab'
import { GroupsTab } from '../../layouts/voices/groupsTab'
import { CreateGroupModal } from '../../layouts/voices/createGroupModal'
import classes from '../../styles/voices/voices.module.scss'
import cn from 'classnames'

export const VoicesPage = () => {
  const dispatch = useDispatch()
  const tab = useSelector((state) => state.voiceGroups.activeTab)
  const [createGroupOpen, setCreateGroupOpen] = useState(false)

  return (
    <Container>
      <div className={classes.voicesPageSection}>
        <div className={classes.voicesHeader}>
          <div className={classes.voicesTabs}>
            <CustomButton
              className={cn(classes.tabButton, tab === 'voices' && classes.tabButtonActive)}
              onClick={() => dispatch(setActiveTab('voices'))}
            >
              Голоса
            </CustomButton>
            <CustomButton
              className={cn(classes.tabButton, tab === 'groups' && classes.tabButtonActive)}
              onClick={() => dispatch(setActiveTab('groups'))}
            >
              Группы
            </CustomButton>
          </div>
          {tab === 'groups' && (
            <CustomButton className={classes.createGroupBtn} onClick={() => setCreateGroupOpen(true)}>
              Создать группу
            </CustomButton>
          )}
          {createGroupOpen && <CreateGroupModal onClose={() => setCreateGroupOpen(false)} />}
        </div>
        {tab === 'voices' && <VoicesTab />}
        {tab === 'groups' && <GroupsTab />}
      </div>
    </Container>
  )
}
